import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 bg-[#1e392a] text-[#f9f6f0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <h3 className="font-serif text-4xl tracking-tight">ARIALOK</h3>
          <p className="mt-4 text-sm text-[#f9f6f0]/70 max-w-sm leading-relaxed">
            Small-batch botanicals for hair and skin. Cold-pressed at the source,
            bottled in glass, never tested on animals.
          </p>
          <div className="flex gap-4 mt-8">
            <a
              href="#"
              data-testid="social-instagram"
              className="p-2 border border-[#f9f6f0]/20 rounded-full hover:bg-[#c36a4f] hover:border-[#c36a4f] transition-colors"
            >
              <Instagram className="h-4 w-4" strokeWidth={1.5} />
            </a>
            <a
              href="#"
              data-testid="social-facebook"
              className="p-2 border border-[#f9f6f0]/20 rounded-full hover:bg-[#c36a4f] hover:border-[#c36a4f] transition-colors"
            >
              <Facebook className="h-4 w-4" strokeWidth={1.5} />
            </a>
            <a
              href="#"
              data-testid="social-twitter"
              className="p-2 border border-[#f9f6f0]/20 rounded-full hover:bg-[#c36a4f] hover:border-[#c36a4f] transition-colors"
            >
              <Twitter className="h-4 w-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>
        <div>
          <p className="overline text-[#c36a4f]">Shop</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-[#c36a4f]">All Products</Link></li>
            <li><Link to="/shop?category=Hair%20Oils" className="hover:text-[#c36a4f]">Hair Oils</Link></li>
            <li><Link to="/shop?category=Skincare" className="hover:text-[#c36a4f]">Skincare</Link></li>
            <li><Link to="/shop?category=Haircare" className="hover:text-[#c36a4f]">Haircare</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-[#c36a4f]">House</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#c36a4f]">About</Link></li>
            <li><a href="#" className="hover:text-[#c36a4f]">Journal</a></li>
            <li><a href="#" className="hover:text-[#c36a4f]">Contact</a></li>
            <li><a href="#" className="hover:text-[#c36a4f]">Wholesale</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#f9f6f0]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#f9f6f0]/50">
          <p>© {new Date().getFullYear()} ARIALOK. All rights reserved.</p>
          <p>Cold-pressed. Cruelty-free. Bottled with intention.</p>
        </div>
      </div>
    </footer>
  );
}
